/**
 * 主题星座（ADR-0011，design §11.10）前端这边的规矩：一个主题有哪几站、第几站、上一站 / 下一站。
 * 一站就是一天：打了这个主题、那天还有照片的日子（照片删光了的回忆在别处都不显示，这里也不算）。
 */
import type { LocalDate } from '@star-sea/shared';

/** 还没有任何主题时，打主题的对话框里给的几个现成的 */
export const THEME_SUGGESTIONS = ['旅行', '美食', '节日', '第一次', '日常'] as const;

/** 一个主题的各站：打了这个主题、那天还有照片的日子，按日期先后；同一天几段回忆算一站 */
export function stationsOf(
  themeId: string,
  memoryThemes: ReadonlyMap<string, ReadonlySet<string>>,
  memoryDate: (memoryId: string) => LocalDate | undefined,
  hasPhotos: (date: LocalDate) => boolean,
): LocalDate[] {
  const days = new Set<LocalDate>();
  for (const [memoryId, themes] of memoryThemes) {
    if (!themes.has(themeId)) continue;
    const date = memoryDate(memoryId);
    if (date && hasPhotos(date)) days.add(date);
  }
  return [...days].sort();
}

/** 现在看的是第几站（从 1 数）；那天不在线上是 0 */
export function stationIndex(stations: readonly LocalDate[], date: LocalDate | null): number {
  return date ? stations.indexOf(date) + 1 : 0;
}

/**
 * 上一站（dir = -1）/ 下一站（1）。现在看的那天不在线上（或者没在看哪天）时，往后是它之后的第一站、往前是它之前的最后一站；
 * 没在看哪天时往后从第一站开始、往前从最后一站开始。到头返回 null（不绕圈：时间线有头有尾）
 */
export function stepStation(stations: readonly LocalDate[], current: LocalDate | null, dir: 1 | -1): LocalDate | null {
  if (!stations.length) return null;
  if (!current) return dir > 0 ? stations[0]! : stations[stations.length - 1]!;
  const at = stations.indexOf(current);
  if (at >= 0) return stations[at + dir] ?? null;
  if (dir > 0) return stations.find((d) => d > current) ?? null;
  for (let k = stations.length - 1; k >= 0; k--) if (stations[k]! < current) return stations[k]!;
  return null;
}
